export default "__VITE_ASSET__eYLCd$EL__"